import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, KeyRound } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AcceptInvitePage() {
  return <TokenPasswordPage mode="accept" />;
}
export function ResetPasswordPage() {
  return <TokenPasswordPage mode="reset" />;
}

function TokenPasswordPage({ mode }) {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const uid = params.get("uid") || "";
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!uid || !token) { toast.error("Link is missing token."); return; }
    if (pw !== pw2) { toast.error("Passwords do not match."); return; }
    setSubmitting(true);
    try {
      const url = mode === "accept" ? "/auth/accept-invite" : "/auth/password-reset/confirm";
      await axios.post(`${API}${url}`, { uid, token, password: pw });
      setDone(true);
      toast.success(mode === "accept" ? "Account activated. Please sign in." : "Password updated. Please sign in.");
      setTimeout(() => nav("/care-portal/admin/login"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message);
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-[calc(100vh-180px)] flex items-center justify-center px-4 py-10" data-testid={`${mode}-page`}>
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-6">
        <div className="flex items-center gap-2 mb-1"><ShieldCheck className="w-5 h-5 text-[#4A6FA5]" /><h1 className="font-heading text-xl text-slate-900">{mode === "accept" ? "Accept invitation" : "Set a new password"}</h1></div>
        <p className="text-xs text-slate-500 mb-4">{mode === "accept" ? "Set a password to activate your CCCHAPS admin account." : "Choose a new password for your CCCHAPS admin account."}</p>
        {done ? (
          <p className="text-sm text-slate-700">You're all set. Redirecting to sign in…</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <label className="block text-xs">
              <span className="font-semibold text-slate-600 uppercase tracking-wider text-[10px]">New password</span>
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid={`${mode}-password`} minLength={10} required className="mt-1 w-full px-3 py-2 rounded border border-slate-300 text-sm" />
            </label>
            <label className="block text-xs">
              <span className="font-semibold text-slate-600 uppercase tracking-wider text-[10px]">Confirm password</span>
              <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid={`${mode}-password-confirm`} minLength={10} required className="mt-1 w-full px-3 py-2 rounded border border-slate-300 text-sm" />
            </label>
            <p className="text-[11px] text-slate-500">Minimum 10 characters, including at least one letter and one digit. Cannot match your email.</p>
            <button type="submit" disabled={submitting} data-testid={`${mode}-submit`} className="w-full inline-flex items-center justify-center gap-1.5 px-4 py-2 rounded-lg bg-[#4A6FA5] hover:bg-[#3B597B] disabled:opacity-60 text-white text-sm font-semibold uppercase tracking-wider"><KeyRound className="w-4 h-4" /> {submitting ? "Working…" : mode === "accept" ? "Activate account" : "Update password"}</button>
            <p className="text-center text-xs text-slate-500 mt-2"><Link to="/care-portal/admin/login" className="text-[#4A6FA5] hover:underline">Back to sign in</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
